// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ISearchEmployeeInfoDto } from './ISearchEmployeeInfoDto';
import {
    ISearchEmployeeInfoDtoFromJSON,
    ISearchEmployeeInfoDtoFromJSONTyped,
    ISearchEmployeeInfoDtoToJSON,
    ISearchEmployeeInfoDtoToJSONTyped,
} from './ISearchEmployeeInfoDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageSearchEmployeeInfoDto
 */
export interface IPageSearchEmployeeInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPageSearchEmployeeInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageSearchEmployeeInfoDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageSearchEmployeeInfoDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ISearchEmployeeInfoDto>}
     * @memberof IPageSearchEmployeeInfoDto
     */
    content?: Array<ISearchEmployeeInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageSearchEmployeeInfoDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageSearchEmployeeInfoDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageSearchEmployeeInfoDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageSearchEmployeeInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageSearchEmployeeInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageSearchEmployeeInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageSearchEmployeeInfoDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageSearchEmployeeInfoDto interface.
 */
export function instanceOfIPageSearchEmployeeInfoDto(value: object): value is IPageSearchEmployeeInfoDto {
    return true;
}

export function IPageSearchEmployeeInfoDtoFromJSON(json: any): IPageSearchEmployeeInfoDto {
    return IPageSearchEmployeeInfoDtoFromJSONTyped(json, false);
}

export function IPageSearchEmployeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageSearchEmployeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ISearchEmployeeInfoDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageSearchEmployeeInfoDtoToJSON(json: any): IPageSearchEmployeeInfoDto {
    return IPageSearchEmployeeInfoDtoToJSONTyped(json, false);
}

export function IPageSearchEmployeeInfoDtoToJSONTyped(value?: IPageSearchEmployeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ISearchEmployeeInfoDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

